"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _OverviewRow = _interopRequireDefault(require("../OverviewRow"));
var _date = require("../../../utils/date");
var CalendarIcon = function CalendarIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8 2a1 1 0 0 1 1 1v1h6V3a1 1 0 1 1 2 0v1h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2V3a1 1 0 0 1 1-1zM7 6H5v3.99h14V6h-2v1a1 1 0 1 1-2 0V6H9v1a1 1 0 0 1-2 0V6zm12 5.99H5V20h14v-8.01z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 14H8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1z"
  }));
};
CalendarIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "icon": "icon_1kQVZA"
}; 
require('./OverviewPublishedOn.css');
var OverviewPublishedOn = function OverviewPublishedOn(_ref) {
  var asset = _ref.asset;
  return /*#__PURE__*/_react.default.createElement(_OverviewRow.default, {
    title: "Published on",
    testId: "asset-published-on"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: styles.icon,
    size: "s",
    isDecorative: true
  }, /*#__PURE__*/_react.default.createElement(CalendarIcon, null)), (0, _date.formatDate)(asset.createdAt));
};
var _default = exports.default = OverviewPublishedOn;
//# sourceMappingURL=OverviewPublishedOn.js.map